import { Injectable } from '@angular/core';
import { CartAuxAdapter } from './cart-aux-adapter';
import { SavedCartsRequest, SetVoucherRequestConfig } from './cart-aux.model';
import { Observable } from 'rxjs';
import { StatusRequest } from '../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class CartAuxService {
  constructor(private cartAuxAdapter: CartAuxAdapter) {}

  setVoucher(config: SetVoucherRequestConfig) {
    return this.cartAuxAdapter.setVoucher(config);
  }

  setNewEmails(emails: string[]): Observable<StatusRequest> {
    return this.cartAuxAdapter.setEmails(emails);
  }

  getSavedCartList(): Observable<SavedCartsRequest> {
    return this.cartAuxAdapter.getSavedCart();
  }

  removeSavedCart(cartId: string): Observable<StatusRequest> {
    return this.cartAuxAdapter.removeSavedCart(cartId);
  }
}
